// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-tooltip {
    position: absolute;
}

.app-tooltip:focus {
    outline: 0;
}

.container {
    width: 320px;
    border: 1px solid #BFBFC0;
    border-bottom: 4px solid #BFBFC0;
    position: relative;
    padding: 8px 10px 12px;
    z-index: 1000;
    background-color: #FFF;
    cursor: move
}

.container:before {
    content: "";
    position: absolute;
    top: 15px;
    right: 98%;
    height: 8px;
    width: 8px;
    background: #FFF;
    transform: rotate(45deg) translate(-50%);
    border-bottom: 1px solid #BFBFC0;
    border-left: inherit;
    box-shadow: inherit;
}

span > img {
    width: 14px;
}

.title {
    font-family: museo-sans, sans-serif;
    font-weight: 500;
    font-size: 13px;
    color: #404141;
    margin-bottom: 10px;
    text-align: left;
}

.close-button {
    margin-top: -6px;
    padding-right: 13px;
}

.content {
    font-family: museo-sans, sans-serif;
    font-weight: 100;
    font-size: 11px;
    color: #404141;
    line-height: 1.5;
    text-align: left;
}

.spacer {
    height: 18px;
}
.help-link {
    cursor: pointer;
    font-size: 12px;
    font-weight: bold;
    float: right;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tooltip/tooltip-content/tooltip-content.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,wCAAwC;IACxC,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;AACA,wkFAAwkF","sourcesContent":[".app-tooltip {\n    position: absolute;\n}\n\n.app-tooltip:focus {\n    outline: 0;\n}\n\n.container {\n    width: 320px;\n    border: 1px solid #BFBFC0;\n    border-bottom: 4px solid #BFBFC0;\n    position: relative;\n    padding: 8px 10px 12px;\n    z-index: 1000;\n    background-color: #FFF;\n    cursor: move\n}\n\n.container:before {\n    content: \"\";\n    position: absolute;\n    top: 15px;\n    right: 98%;\n    height: 8px;\n    width: 8px;\n    background: #FFF;\n    transform: rotate(45deg) translate(-50%);\n    border-bottom: 1px solid #BFBFC0;\n    border-left: inherit;\n    box-shadow: inherit;\n}\n\nspan > img {\n    width: 14px;\n}\n\n.title {\n    font-family: museo-sans, sans-serif;\n    font-weight: 500;\n    font-size: 13px;\n    color: #404141;\n    margin-bottom: 10px;\n    text-align: left;\n}\n\n.close-button {\n    margin-top: -6px;\n    padding-right: 13px;\n}\n\n.content {\n    font-family: museo-sans, sans-serif;\n    font-weight: 100;\n    font-size: 11px;\n    color: #404141;\n    line-height: 1.5;\n    text-align: left;\n}\n\n.spacer {\n    height: 18px;\n}\n.help-link {\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: bold;\n    float: right;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
